import { marketplaceTypes } from "../data/linkTypes";
import type { ReviewableLink } from "../types";

/**
 * Given a collection of ReviewableLinks, return a marketplace link
 */
const getMarketplaceLink = (links: ReviewableLink[]) => {
  // Iterate over array of marketplace link types and return the first match
  for (const type of marketplaceTypes) {
    const reviewableLink = links.find((link) => link.type === type);
    if (reviewableLink) return reviewableLink;
  }
  return undefined;
};

export { getMarketplaceLink };
